export const isOnMaintenance = () =>
  process.env.REACT_APP_ON_MAINTENANCE === 'true' &&
  !localStorage.getItem('skipMaintenance');
